import React, { Component } from 'react';
import { Router, Route } from 'react-router-dom';
//import { history } from './helpers';
import PropTypes from 'prop-types';
//import { PrivateRoute } from './components';
import { OidcProvider } from 'redux-oidc';
//import {LogIn} from './login/LogIn.js';
//import CallbackPage from '../components/callback';
//import { store } from './helpers';
import { getUserManager } from './util/userManager';
import { ConnectedRouter } from 'connected-react-router';
//import {Invoice} from "./invoice/invoice.js";
//import {Shipment} from "./shipment/shipment.js";
import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.css';
import './App.css';
import Routes from './routes';
import "babel-polyfill";

const App = ({ history, store }) => {
  console.log('store:',store,'history:',history);
  return (
    <OidcProvider store={store} userManager={getUserManager()}>    
      <ConnectedRouter history={history}>
        {Routes}
      </ConnectedRouter>
    </OidcProvider>
  );
}
App.propTypes = {
  history: PropTypes.object.isRequired
}
export default (App);